import Cookies from 'js-cookie';
import { ContextBuilder } from './context/context-builder';
import { getButtonConfig } from './utils/button-utils/helper';
import { isChatSessionActive } from './utils/sf-utils/chat-session';
import { initSFChat } from './components/sf-component/miaw-chat';
import { initNR, logNR } from './utils/app-utils/nr-logging';
import { createFloatingButton } from './components/ca-button/ca-button';
import { checkBusinessHours } from './utils/api-utils/gcp-api';
import { getUserData } from './utils/api-utils/user-profile-api';
import { getChatConfig } from './utils/app-utils/chat-config-utils';
import { handleOutsideBH } from './utils/button-utils/custom-button-utils';

export const initCA = (forceInit = false) => {
  /** Get Button config
   * @enableChat : whether chat is enabled on the given page
   * @buttonType : floating or inline
   */
  const { enableChat, buttonType } = getButtonConfig();
  console.info('Button config', { enableChat, buttonType });

  const isSessionActive = isChatSessionActive();

  /** Start loading chat if explicitly set , or session is active , or chat is available on the page */
  if (forceInit || isSessionActive || enableChat) {
    /** Check Business hour */
    checkBusinessHours()
      .then(async (data) => {
        handleOutsideBH(data, enableChat);
        const chatStatus = data?.status?.isChatEnabled;

        const userInfo = await getUserData();

        console.info({ userInfo, chatStatus });
        /** If Chat is enabled from GCP or Sandbox env */
        if (chatStatus || getChatConfig().checkBusinessHour === false || Cookies.get('ca-disable-bh') === 'true') {
          const context = await ContextBuilder();
          console.info({ context });
          /** In button is floating, create the button
           * If session is active, do not display the button -> minimized button will be shown from SF
           */
          if (buttonType === 'floating' || buttonType === 'hybrid' || isSessionActive) {
            createFloatingButton(context, true);
          } else {
            /** For Inline button, keep the button hidden, will be used for minimized state later on */
            createFloatingButton(context, false);
          }
          /** Load SF scripts */
          initSFChat(context, userInfo);
        } else {
          console.info('Chat is disabled outside business hours', { chatStatus });
        }
      })
      .catch((error) => {
        const e = error as Error;
        console.error('Error in CA init', e);
        logNR('CA_ERROR', { errorMessage: e.message, errorStack: e.stack });
      });
  }
};

/** Fn to init CA based on event */
export const initCAfromExternalSource = () => {
  document.addEventListener('initCA', () => {
    initNR();
    initCA(true);
  });
  document.addEventListener('HPLoadChat', () => {
    initNR();
    initCA(true);
  });
};
